import { render, staticRenderFns } from "./MfForm.vue?vue&type=template&id=0db4e4d2&"
import script from "./MfForm.vue?vue&type=script&lang=js&"
export * from "./MfForm.vue?vue&type=script&lang=js&"
import style0 from "./MfForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports